import { useState } from "react";
import { Link } from "react-scroll";
import Apply from "../apply";
import bg from "./img/bg.png";
export default function Home() {
  const [openApply, setOpenApply] = useState<boolean>(false);
  return (
    <div
      style={{ backgroundImage: `url("${bg}")` }}
      className="bg-center pt-72 pb-20 text-center bg-cover"
    >
      <Apply
        isOpen={openApply}
        onClose={() => {
          setOpenApply(false);
        }}
      />
      <div className="container mx-auto p-4 lg:p-10 max-w-[1529px]">
        <p className="text-5xl text-[#ffd176] text-shadow font-cookie-black uppercase mt-0 md:mt-40">
          PARTNER WITH MONSTERRA
        </p>
        <p className="text-xl mt-2">
          Let’s Make Game Change For Future GameFi!
        </p>
        <div className="flex justify-center mt-8 gap-2">
          <img
            onClick={() => {
              setOpenApply(true);
            }}
            src={require("./img/btn-apply.png")}
            className="h-14 object-contain cursor-pointer"
          />
          <a
            href="https://t.me/lledo111"
            target="_blank"
            className=" inline-block"
          >
            <img
              src={require("./img/btn-chat.png")}
              className="h-14 object-contain"
            />
          </a>
        </div>
        <div className="w-full flex justify-between items-center mt-8 flex-col lg:flex-row gap-4 max-w-[1024px] mx-auto">
          <p className="text-2xl font-cookie-black w-56 flex-shrink-0 text-[#524433]">
            BACKED BY
          </p>
          <div className="hidden lg:block">
            <img
              src={require("./img/partners.png")}
              className="h-10 w-full object-contain flex-grow-0"
            />
          </div>
          <div className="lg:hidden flex-shrink-0 overflow-x-auto w-full">
            <img
              src={require("./img/partners.png")}
              className="w-[900px] max-w-none"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
